<style scoped>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #502d0c;
    }

    .a:active {
        color: green;
    }

</style>

<template>
    <div id="app">
        <ezu-top-menu></ezu-top-menu>
        <router-view style="padding-top: 100px;"></router-view>
    </div>

</template>

<script>
    import ezuTopMenu from './components/common/ezuTopMenu'
    export default {
        name: 'app',
        components: {ezuTopMenu},
    }
</script>





// WEBPACK FOOTER //
// src/App.vue